import Swal from 'sweetalert2'
import {
    IS_LOADING_LIST_PQRS_ADMIN,LIST_PQRS_ADMIN,IS_LOADING_RESPONSE_PQRS_ADMIN,RESPONSE_PQRS_ADMIN,
    DISABLE_PQRS_ADMIN
} from './types'
import {
    IS_LOADING_LIST_PQRS_USER, DISABLE_PQRS_USER
} from '../../actions/types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';


//pqrs of admin


export const getListPQRS = (history) => async dispatch => {
    await fetch(`${urlServer}api/pqrsadmin`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, 
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true){
                { dispatch({ 
                    type: IS_LOADING_LIST_PQRS_ADMIN
                });
                dispatch({ 
                    type: LIST_PQRS_ADMIN,
                    payload: respJson.data
                });}
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getListTypePQRS = (type, index) => async dispatch => {
console.log()
    await fetch(`${urlServer}pqrs/get-by-status`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({status: type })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true)
            {dispatch({ 
                type: IS_LOADING_LIST_PQRS_ADMIN
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_PQRS_ADMIN,
                payload: respJson.data
            });}
           
        })
        .catch(error => {
            console.log()
        })
}

export const responsePQRS = (response, history, index) => async dispatch => {
console.log()
        await fetch(`${urlServer}pqrs/update`, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${inMemoryJWT.getToken()}`
                    // 'Content-Type': 'application/x-www-form-urlencoded',
    
                }, // body data type must match "Content-Type" header    
                body: JSON.stringify(response)
            })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                if(respJson.success===true)
            {dispatch({ 
                type: IS_LOADING_RESPONSE_PQRS_ADMIN
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: RESPONSE_PQRS_ADMIN,
                payload: respJson.data
            });}
            })
            .catch(error => {
                console.log()
            })
}

export const disablePQRS = (disable,index, history) => async dispatch => {
 console.log()
    await fetch(`${urlServer}api/pqrsadmin/disable`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify(disable)
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true)
           { dispatch({ 
                type: IS_LOADING_LIST_PQRS_ADMIN
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DISABLE_PQRS_ADMIN,
                payload: index
            });
        }
        })
        .catch(error => {
            console.log()
        })
}
